import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {  MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MailDetalle } from 'src/app/models/MailDetalle';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';

@Component({
  selector: 'app-modal-mail-detalle',
  templateUrl: './modal-mail-detalle.component.html',
  styleUrls: ['./modal-mail-detalle.component.css']
})
export class ModalMailDetalleComponent implements OnInit {

  strContenido = '';
  mailDetalle: MailDetalle = null;


  @ViewChild(NavModalComponent) navModalC: NavModalComponent;

  constructor(private dialogRef: MatDialogRef<ModalMailDetalleComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {

    this.mailDetalle = this.data.mailDetalle;

    this.navModalC.setDatosNavModal2('Materia del hecho irregular');

    this.strContenido = this.mailDetalle.cbpmmaildetContenido;




  }

  _cerrarModal() {
    this.dialogRef.close();
  }


}
